import Vue from 'vue';

Vue.directive('track', {
    inserted: function (el, binding) {
        el.addEventListener(binding.value, event => sendEventTracking(event.target, binding.value));
    }
});

// Declarative Event Tracking (Backwards Compatible)
function sendEventTracking(src, eventHandler) {
    let category = src.getAttribute('data-ga-category');
    let action = src.getAttribute('data-ga-action') ? src.getAttribute('data-ga-action') : eventHandler;
    let label = src.getAttribute('data-ga-label') ? src.getAttribute('data-ga-label') : src.innerHTML.trim();
    gaTracking.sendEvent(category, action, label);
}


// WEBPACK FOOTER //
// ../default-js/js/directives/eventTracking.js